<template>
  <div class="small-rounded-btn delete">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.478"
      height="13.478"
      viewBox="0 0 13.478 13.478"
    >
      <g
        id="Gruppe_274"
        data-name="Gruppe 274"
        transform="translate(1.414 1.414)"
      >
        <line
          id="Linie_34"
          data-name="Linie 34"
          x2="10.65"
          y2="10.65"
          fill="none"
          stroke="rgba(221,112,3,0.87)"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2"
        />
        <line
          id="Linie_35"
          data-name="Linie 35"
          x1="10.65"
          y2="10.65"
          fill="none"
          stroke="rgba(221,112,3,0.87)"
          stroke-linecap="round"
          stroke-miterlimit="10"
          stroke-width="2"
        />
      </g>
    </svg>
  </div>
</template>
